import { MockFactory } from '@tino-frontend/mocks'
import type { PaymentLinkDetail } from '@types'
import { PaymentLinkStatus } from '@types'
import { paymentLinkDetailBaseMock } from './payment-link-detail-base'

const mockedData = paymentLinkDetailBaseMock.build()

export const paymentLinkDetailReservationExpiredMock =
  new MockFactory<PaymentLinkDetail>({
    ...mockedData,
    amount_cents: 1000,
    status: PaymentLinkStatus.ReservationExpired,
    invoices: [{ ...mockedData.invoices[0]!, amount_cents: 0 }],
  })
